<template>
  <v-container v-if="ticketProfile" id="wizard" tag="section">
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      class="px-5 my-12 py-3 pb-12"
    >
      <template v-slot:after-heading>
        <div class="headline text-no-wrap font-weight-bold d-flex">
          {{ $t("ticket.labels.ticketProfile") }}
        </div>
      </template>

      <v-card-title
        class="d-flex"
        v-if="ticketProfile && ticketProfile.parentIds"
        >[{{ getLabel(ticketProfile) }}] {{ ticketProfile.title }}
        <v-spacer></v-spacer
        ><v-chip
          light
          class="black--text"
          :color="getStatus(ticketProfile.customStatusId).color"
          >{{ getStatus(ticketProfile.customStatusId).name }}</v-chip
        >
      </v-card-title>
      <v-card-text v-html="ticketProfile.description"> </v-card-text>
      <v-card-subtitle
        >{{ $t("ticket.labels.published") }}
        {{
          ticketProfile.createdDate | formatWithIntlWithTime
        }}</v-card-subtitle
      >

      <v-divider class="mb-12"></v-divider>

      <v-btn
        class="mx-1"
        small
        text
        color="primary"
        @click="downloadExport(attachment)"
        v-for="(attachment, index) in ticketProfile.attachments"
        :key="index"
      >
        <v-icon>mdi-paperclip</v-icon> {{ attachment.name }} ({{
          (attachment.size / 1000).toFixed(2)
        }}
        kb)</v-btn
      >

      <v-btn absolute fab left bottom @click="expand = !expand" color="primary"
        ><v-icon>mdi-reply</v-icon></v-btn
      >
      <v-btn
        absolute
        fab
        right
        bottom
        @click="dialogAttach = !dialogAttach"
        color="primary"
        ><v-icon>mdi-attachment</v-icon>
      </v-btn>
    </base-material-card>
    <v-expand-transition>
      <v-card v-show="expand" class="mb-12">
        <v-card-title class="primary white--text"
          >{{ $t("ticket.labels.addNewComment") }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row class="mx-auto" justify="space-around">
              <v-col cols="12" md="12">
                <v-textarea
                  outlined
                  class="mt-12"
                  v-model="comment"
                  color="gray"
                  :label="$t('ticket.labels.comment')"
                  :rules="[
                    v => v.length >= 5 || $t('ticket.messages.commentMinError'),
                    v =>
                      v.trim() !== '' || $t('ticket.messages.commentNullError')
                  ]"
                />
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!valid"
                rounded
                width="200"
                x-large
                color="primary"
                @click="submit"
                >{{ $t("ticket.buttons.submit") }}</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-expand-transition>
    <v-expand-transition>
      <v-card v-show="dialogAttach" class="mb-12">
        <v-card-title class="primary white--text">Attachment </v-card-title>
        <v-card-text>
          <v-row class="mx-auto" justify="space-around">
            <v-col cols="12" md="12">
              <v-file-input
                class="my-10"
                prepend-icon="mdi-folder-multiple-image"
                accept="*"
                ref="file"
                @change="uploadFiles"
                :loading="loadingFile"
                :label="$t('inspectionProfile.fileInput')"
                outlined
                dense
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-expand-transition>
    <base-subheading
      :subheading="$t('ticket.labels.comments')"
      v-if="ticketProfile.comments && ticketProfile.comments.length > 0"
    >
    </base-subheading>
    <v-row>
      <v-col
        cols="12"
        v-for="(item, index) in ticketProfile.comments"
        :key="index"
      >
        <base-material-alert
          v-if="notEmpty(item.text)"
          class="elevation-4 black--text my-0"
          color="#fafafa"
        >
          <template v-if="hasFrom(item.text)">
            <v-chip color="primary" label small class="white--text">{{
              $t("ticket.labels.team")
            }}</v-chip
            ><br />
          </template>

          <span class="" v-html="item.text" />
          <br />
          <span class="caption">
            {{ item.updatedDate | formatWithIntlWithTime }}</span
          >
        </base-material-alert></v-col
      >
    </v-row>

    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("ticket.buttons.backbtn") }}</span>
    </v-tooltip>
  </v-container>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import { sdIssuesWorkflow, foldersId } from "../../utils/wrikeHelper";
export default {
  name: "TicketProfile",
  components: {},

  data: () => ({
    ticket: {},
    comment: "",
    valid: true,
    expand: false,
    tab: 0,
    dialogAttach: false,
    tabs: ["Ticket details"],
    subject: "",
    content: "",
    attachments: [],
    loadingFile: false
  }),
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    try {
      await this.$store.dispatch(
        "tickets/bindTicketProfile",
        this.$route.params.id
      );
    } catch (error) {
      console.error(error);
    }
    loading.close();
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("tickets", ["ticketProfile"]),
    availableSteps() {
      const steps = [0];
      if (this.subject !== "" && this.content !== "") steps.push(1);
      return steps;
    }
  },
  methods: {
    downloadExport(file) {
      var config = {
        method: "GET",
        url: `https://www.wrike.com/api/v4/attachments/${file.id}/download`,
        responseType: "blob",
        headers: {
          authorization: `Bearer ${process.env.VUE_APP_WRIKE_API}`
        }
      };
      axios(config).then(response => {
        console.log(
          "🚀 ~ file: Index.vue ~ line 239 ~ axios ~ response",
          response
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
      }); // Please catch me!
    },

    async uploadFiles(file) {
      this.loadingFile = true;
      try {
        var config = {
          method: "post",
          url: `https://www.wrike.com/api/v4/tasks/${this.ticketProfile.id}/attachments`,
          headers: {
            authorization: `Bearer ${process.env.VUE_APP_WRIKE_API}`,
            "content-type": "application/octet-stream",
            "X-Requested-With": "XMLHttpRequest",
            "X-File-Name": file.name
          },
          data: file
        };
        await axios(config);
        this.dialogAttach = false;
        this.loadingFile = false;
        this.$dialog.notify.success("The attachment was added successfully", {
          position: "top-right",
          timeout: 5000
        });
      } catch (error) {
        console.error(error);
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
    },
    getLabel(item) {
      const label = [...item.parentIds];
      const checkIncludes = folder => label.includes(folder);
      switch (true) {
        case checkIncludes(foldersId.issues): // Issue Id Folder
          console.log("foldersId.issues", true);
          return this.$t("ticket.labels.issues");
        case checkIncludes("IEADCDYKI4QZOUIM"): // Hardware Id Folder
          console.log("foldersId.hardware", true);
          return this.$t("ticket.labels.mechanicalSupport");
        case checkIncludes(foldersId.suggestions): // Suggestion id folder
          console.log("foldersId.suggestions", true);
          return this.$t("ticket.labels.suggestions");
        default:
          return this.$t("ticket.labels.issues");
      }
    },
    notEmpty(text) {
      if (text !== "") {
        return true;
      }
      return false;
    },
    hasFrom(text) {
      const re = /FROM/i;
      let match = re.test(text);
      return !match;
    },
    getStatus(status) {
      switch (status) {
        case sdIssuesWorkflow.new:
          return { name: this.$t("ticket.labels.new"), color: "blue" };
        case sdIssuesWorkflow.inProgress:
          return { name: this.$t("ticket.labels.inProgress"), color: "cyan" };
        case sdIssuesWorkflow.waitingOnCustomerFeedback:
          return {
            name: this.$t("ticket.labels.waitingOnCustomerFeedback"),
            color: "yellow"
          };
        case sdIssuesWorkflow.resolved:
          return { name: this.$t("ticket.labels.resolved"), color: "lime" };
        case sdIssuesWorkflow.duplicated:
          return {
            name: this.$t("ticket.labels.duplicated"),
            color: "indigo lighten-4"
          };
        case sdIssuesWorkflow.cancelled:
          return {
            name: this.$t("ticket.labels.cancelled"),
            color: "grey lighten-2"
          };
        default:
          return {
            name: this.$t("ticket.labels.other"),
            color: "grey lighten-2"
          };
      }
    },
    next(valid) {
      if (!valid) return;
      this.submit();
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const { ticketProfile } = this;
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });

        try {
          const bodyParameters = {
            text: `<p>[FROM] ${this.user.firstName} ${this.user.lastName}:<br/> ${this.comment}</p>`,
            plainText: true
          };
          const config = {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_WRIKE_API}`
            }
          };
          await axios.post(
            `https://www.wrike.com/api/v4/tasks/${ticketProfile.id}/comments`,
            bodyParameters,
            config
          );
          this.$refs.form.reset();
          loading.close();

          this.$dialog.notify.success("The comment was added successfully", {
            position: "top-right",
            timeout: 5000
          });
          this.expand = false;
        } catch (error) {
          loading.close();
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      } else {
        this.$dialog.notify.error(
          "El comentario debe contener al menos 5 caracteres",
          {
            position: "top-right",
            timeout: 5000
          }
        );
      }
    }
  }
};
</script>
<style scoped>
.v-application a {
  color: white !important;
}
</style>
